import { createSelector } from 'reselect'

import { selectBasicInfoState } from './selectBasicInfoState'

export const selectDefaultBasicInfo = createSelector(
  [selectBasicInfoState],
  ({ defaultData }) => defaultData
)
